/**
 * @Author : ZhuYongFang
 * @Date : 2019/5/30
 * @Version : 1.0
 * @Content : 任务管理
 */
// import $http from '@/utils/fetch'
import $http from '@/utils/requestAxios'

export const apiTask = {
  // 列表
  list (query, page = 1, size = 10) {
    return $http.get('/jobs', { ...query, page, size })
  },
  // 运行日志下载
  logFile (jobNo = '') {
    return $http.get('/developer/runlogs', { jobNo }, {}, 'store')
  },
  openLogFile (jobNo = '') {
    return `${process.env.VUE_APP_REPORTURL}store/v1/developer/runlogs?jobNo=${jobNo}`
  },
  // 停止
  stop (query) {
    return $http.put('/jobs', query)
  },
  // 启动
  start (query) {
    return $http.post('/jobs/restart', query)
  },
  // 重做
  reStart (query) {
    return $http.post('/jobs/retry', query)
  },
  // 删除
  del (query) {
    return $http.delete('/jobs', query)
  }
}
